module.exports = __webpack_public_path__ + "media/images/icons/ic-avatar-white-b16cd635eb4b4f851702d1727b839406.svg";